import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

const CNBCLive = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [key, setKey] = useState(Date.now()); // Used to force iframe reload

  // YouTube video ID for CNBC live stream
  const videoId = "9NyxcX3rhQs";
  
  // Use privacy-enhanced mode URL
  const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&rel=0&modestbranding=1`;

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const handleIframeError = () => {
    setError(true);
    setLoading(false);
  };

  const handleRetry = () => {
    setLoading(true);
    setError(false);
    setKey(Date.now()); // Force iframe reload with new key
  };

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 200px)' }}>
      <Paper 
        elevation={3} 
        sx={{ 
          width: '100%', 
          height: '100%',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        {loading && (
          <Box 
            sx={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.7)'
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {error ? (
          <Box 
            sx={{ 
              width: '100%', 
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 3
            }}
          >
            <Alert 
              severity="warning" 
              sx={{ mb: 3, width: '70%' }}
            >
              Unable to load CNBC Live stream. This might be due to ad blocking software or network restrictions.
            </Alert>
            <Button 
              variant="contained" 
              color="primary"
              onClick={handleRetry}
            >
              Retry
            </Button>
            <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
              Alternatively, you can watch CNBC TV directly on their website at{' '}
              <a href="https://www.cnbc.com/live" target="_blank" rel="noopener noreferrer">
                bloomberg.com/live
              </a>
            </Typography>
          </Box>
        ) : (
          <iframe
            key={key}
            src={embedUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            title="Live CNBC TV"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        )}
      </Paper>
    </Box>
  );
};

export default CNBCLive;